import React from 'react';
import {useEffect} from 'react';
import "./style.css";
import logo from '../../images/logo.png';
import logo_negativo from '../../images/logo_negativo.png';
import fachada from '../../images/FACHADA1.png';
import logoS from '../../images/logoS.png';
import videoOrtodoncia1 from '../../videos/ortodoncia2.mp4';
import videoAlineadores from '../../videos/alineadores.mp4';
import videoEndodoncia from '../../videos/endodoncia.mp4';
import videoPeriodoncia from '../../videos/periodontia.mp4';
import videoMaxilofacial from '../../videos/maxilofacial.mp4';
import videoOdontopediatria from '../../videos/odontopediatria.mp4';
import videoEsteticaDental from '../../videos/esteticadental.mp4';
import videoRehabilitacion from '../../videos/rehabilitacion.mp4';
import fachadaUbicacion from '../../images/fachada.png';
import DynamicCollage from '../DynamicCollage';
import Carousel3D from '../Carousel3D';

const Menu = () => {

    useEffect(() => {
        document.title = "VeraDental | Ortodoncia & Especialidades";
        document.getElementsByTagName("html")[0].classList = "";
        document.getElementsByTagName("html")[0].classList.add("estiloMenu");
        document.getElementsByTagName("html")[0].style.overflowY = "auto";
    }, []);

    return (
        <React.Fragment>
            <header>
                <div className="left">
                    <img onClick={() => {
                        document.getElementById("inicio").style.display = "block";
                        document.getElementById("servicios").style.display = "none";
                        document.getElementById("sucursales").style.display = "none";
                        document.getElementById("contacto").style.display = "none";
                    }} className='animate__animated animate__fadeIn animate__slow' src={logo} alt="Logo VeraDental"/>
                </div>

                <div
                    className='menu animate__animated animate__fadeIn animate__slow'
                    onClick={() => {
                        document.getElementsByTagName("html")[0].style.overflowY = "hidden";
                        document.getElementById("menu").style.display = "flex";
                    }}
                >
                    <i className="fa-solid fa-bars"></i>
                </div>

                <div className="right" id='menu'>
                    <div
                        className="close"
                        onClick={(e) => {
                            e.target.closest(".right").style.display = "none";
                            document.getElementsByTagName("html")[0].style.overflowY = "auto";
                        }}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </div>
                    <img className='logo-menu animate__animated animate__fadeIn animate__slow' id='logo-menu' src={logo_negativo} alt="Logo VeraDental"/>
                    <div
                        className="option animate__animated animate__fadeIn animate__slow"
                        onClick={() => {
                            if(document.getElementById("logo-menu").style.display != "none") {
                                document.getElementById("menu").style.display = "none";
                                document.getElementsByTagName("html")[0].style.overflowY = "auto";
                            }
                            document.getElementById("inicio").style.display = "block";
                            document.getElementById("servicios").style.display = "none";
                            document.getElementById("sucursales").style.display = "none";
                            document.getElementById("contacto").style.display = "none";
                        }}
                    >
                        Inicio
                    </div>
                    <div
                        className="option animate__animated animate__fadeIn animate__slow"
                        onClick={() => {
                            if(document.getElementById("logo-menu").style.display != "none") {
                                document.getElementById("menu").style.display = "none";
                                document.getElementsByTagName("html")[0].style.overflowY = "auto";
                            }
                            document.getElementById("inicio").style.display = "none";
                            document.getElementById("servicios").style.display = "block";
                            document.getElementById("sucursales").style.display = "none";
                            document.getElementById("contacto").style.display = "none";
                        }}
                    >
                        Servicios Dentales
                    </div>
                    <div
                        className="option animate__animated animate__fadeIn animate__slow"
                        onClick={() => {
                            if(document.getElementById("logo-menu").style.display != "none") {
                                document.getElementById("menu").style.display = "none";
                                document.getElementsByTagName("html")[0].style.overflowY = "auto";
                            }
                            document.getElementById("inicio").style.display = "none";
                            document.getElementById("servicios").style.display = "none";
                            document.getElementById("sucursales").style.display = "block";
                            document.getElementById("contacto").style.display = "none";
                        }}
                    >
                        Sucursales
                    </div>
                    <div
                        className="option animate__animated animate__fadeIn animate__slow"
                        onClick={() => {
                            if(document.getElementById("logo-menu").style.display != "none") {
                                document.getElementById("menu").style.display = "none";
                                document.getElementsByTagName("html")[0].style.overflowY = "auto";
                            }
                            document.getElementById("inicio").style.display = "none";
                            document.getElementById("servicios").style.display = "none";
                            document.getElementById("sucursales").style.display = "none";
                            document.getElementById("contacto").style.display = "block";
                        }}
                    >
                        Contacto
                    </div>
                    <div onClick={() => window.open('https://wa.me/2222382872', '_blank').focus()} className="whats animate__animated animate__fadeIn animate__slow">
                        <i className="fa-brands fa-whatsapp"></i>
                    </div>
                </div>
            </header>

            <div id="inicio">
                <div>
                    <DynamicCollage />
                </div>

                <div id="init">
                    <div className="welcome">
                        <h2 className='animate__animated animate__slideInLeft'>Mereces transformar tu sonrisa</h2>
                        <button className='animate__animated animate__zoomIn animate__delay-1s' onClick={() => window.open('https://wa.me/2222382872?text=Hola,%20deseo%20agendar%20una%20cita%20en%20VeraDental.', '_blank').focus()}>
                            <i className="fa-solid fa-clipboard-check"></i>
                            <p>AGENDA TU CITA</p>
                        </button>
                    </div>
                </div>

                <div id="mision" className='animate__animated animate__fadeIn'>
                    <div className="left">
                        <h4>Nuestra</h4>
                        <h3>Misión</h3>
                        <p>Brindar atención odontológica especializada e integral, con un alto compromiso de calidad y profesionalismo, apoyados en la innovación y un trato humano cercano, para transformar sonrisas y garantizar salud bucal duradera en cada paciente.</p>
                    </div>
                    <div className="right">
                        <img src={fachada} alt="fachada-veradental" />
                    </div>
                </div>

                <div id="invitacion">
                    <div className="social-medias">
                        <div className="option" onClick={() => window.open('https://www.facebook.com/share/1DPrGb3x1g/', '_blank').focus()}>
                            <i className="fa-brands fa-facebook"></i>
                        </div>
                        <div className="option" onClick={() => window.open('https://www.instagram.com/dra.angelicavera_ortodoncista?igsh=MTczYmhhcGRubDg4ZQ==', '_blank').focus()}>
                            <i className="fa-brands fa-instagram"></i>
                        </div>
                        <div className="option" onClick={() => window.open('https://www.tiktok.com/@dra.angelica.vera', '_blank').focus()}>
                            <i className="fa-brands fa-tiktok"></i>
                        </div>
                        <div className="option" onClick={() => window.open('mailto:veradental.ortodoncia@gmail.com', '_blank').focus()}>
                            <i className="fa-solid fa-envelope"></i>
                        </div>
                    </div>

                    <button onClick={() => {
                        document.getElementById("inicio").style.display = "none";
                        document.getElementById("servicios").style.display = "block";
                        document.getElementById("sucursales").style.display = "none";
                        document.getElementById("contacto").style.display = "none";
                        window.scrollTo({top: 0, behavior: 'smooth'});
                    }}>
                        <i className="fa-solid fa-tooth"></i>
                        <p>Conoce nuestros servicios</p>
                    </button>
                </div>

                <div id="accion">
                    <img src={logoS}/>
                    <h4>Nuestros</h4>
                    <h3>Valores</h3>
                    <div className="lista-valores">
                        <div className="valor">
                            <h2>Confianza</h2>
                            <p>Creemos en la importancia de generar seguridad y tranquilidad en cada paciente.</p>
                        </div>
                         <div className="valor">
                            <h2>Profesionalismo</h2>
                            <p>Nos guiamos por la ética, la calidad y la excelencia en cada tratamiento.</p>
                        </div>
                         <div className="valor">
                            <h2>Empatía</h2>
                            <p>Escuchamos y entendemos las necesidades de cada paciente con cercanía.</p>
                        </div>
                         <div className="valor">
                            <h2>Compromiso</h2>
                            <p>Dedicados a lograr resultados reales y mejorar la salud bucal integral.</p>
                        </div>
                         <div className="valor">
                            <h2>Pasión</h2>
                            <p>Amamos lo que hacemos: transformar vidas a través de las sonrisas.</p>
                        </div>
                    </div>

                    <p className="llamada-accion">¡Agenda tu cita hoy mismo!</p>
                    <i className="fa-solid fa-arrow-down"></i>
                    <button onClick={() => window.open('https://wa.me/2222382872?text=Hola,%20deseo%20agendar%20una%20cita%20en%20VeraDental.', '_blank').focus()}>
                        <i className="fa-solid fa-clipboard-check"></i>
                        <p>AGENDA TU CITA</p>
                    </button>
                </div>

                <div className='equipo'>
                    <center><h4>Nuestro</h4></center>
                    <center><h3>Equipo</h3></center>
                    <Carousel3D />
                </div>
            </div>

            <div id="servicios" style={{"display":"none"}}>
                <div className="title">
                    <h2 className='animate__animated animate__fadeIn'>Algunos de nuestros</h2>
                    <h1 className='animate__animated animate__fadeInUp'>servicios dentales</h1>
                </div>

                <div className="lista-servicios">
                    <div className="servicio izq">
                        <div className="left">
                            <video autoPlay muted loop playsInline>
                                <source src={videoOrtodoncia1} type="video/mp4" />
                            </video>
                        </div>
                        <div className="right">
                            <h3 className='animate__animated animate__fadeIn'>Ortodoncia</h3>
                            <p className='animate__animated animate__fadeIn'>Es la especialidad que se encarga de alinear los dientes y mejorar la función en la mordida. Se corrige con brackets o alineadores transparentes para lograr una sonrisa estética y funcional, mejorando tanto la apariencia como la salud dental.</p>
                            <button onClick={() => window.open('https://wa.me/2222382872?text=Hola,%20deseo%20agendar%20una%20cita%20en%20VeraDental%20para%20ortodoncia.', '_blank').focus()}>
                                <i className="fa-solid fa-tooth"></i>
                                <p>AGENDAR CITA PARA ORTODONCIA</p>
                            </button>
                        </div>
                    </div>

                    <div className="servicio der">
                        <div className="left">
                            <video autoPlay muted loop playsInline>
                                <source src={videoAlineadores} type="video/mp4" />
                            </video>
                        </div>
                        <div className="right">
                            <h3 className='animate__animated animate__fadeIn'>Alineadores invisibles</h3>
                            <p className='animate__animated animate__fadeIn'>Son un sistema de ortodoncia removible que utiliza una serie de férulas transparentes, hechas a la medida del paciente, para mover los dientes de forma gradual y controlada.<br/><br/>Cada alineador ejerce una ligera presión que permite corregir la posición dental y mejorar la mordida, siguiendo una planificación previa del tratamiento.</p>
                            <button onClick={() => window.open('https://wa.me/2222382872?text=Hola,%20deseo%20agendar%20una%20cita%20en%20VeraDental%20para%20alineadores.', '_blank').focus()}>
                                <i className="fa-solid fa-tooth"></i>
                                <p>AGENDAR CITA PARA ALINEADORES</p>
                            </button>
                        </div>
                    </div>

                    <div className="servicio izq">
                        <div className="left">
                            <video autoPlay muted loop playsInline>
                                <source src={videoEndodoncia} type="video/mp4" />
                            </video>
                        </div>
                        <div className="right">
                            <h3 className='animate__animated animate__fadeIn'>Endodoncia</h3>
                            <p className='animate__animated animate__fadeIn'>Se realiza este tratamiento cuando el nervio del diente se inflama o se infecta, generalmente por caries profundas o fracturas. Consiste en limpiar el interior del diente, eliminar el tejido dañado y sellarlo adecuadamente. Su objetivo es aliviar el dolor, eliminar la infección y conservar el diente natural el mayor tiempo posible.</p>
                            <button onClick={() => window.open('https://wa.me/2222382872?text=Hola,%20deseo%20agendar%20una%20cita%20en%20VeraDental%20para%20endodoncia.', '_blank').focus()}>
                                <i className="fa-solid fa-tooth"></i>
                                <p>AGENDAR CITA PARA ENDODONCIA</p>
                            </button>
                        </div>
                    </div>

                    <div className="servicio der">
                        <div className="left">
                            <video autoPlay muted loop playsInline>
                                <source src={videoPeriodoncia} type="video/mp4" />
                            </video>
                        </div>
                        <div className="right">
                            <h3>Periodoncia</h3>
                            <p>Se enfoca en cuidar la encía, el hueso y los tejidos que rodean los dientes, previniendo o tratando la inflamación y el sangrado, así como enfermedades como la gingivitis y la periodontitis, para mantener los dientes firmes, libres de movilidad.</p>
                            <button onClick={() => window.open('https://wa.me/2222382872?text=Hola,%20deseo%20agendar%20una%20cita%20en%20VeraDental%20para%20periodoncia.', '_blank').focus()}>
                                <i className="fa-solid fa-tooth"></i>
                                <p>AGENDAR CITA PARA PERIODONCIA</p>
                            </button>
                        </div>
                    </div>

                    <div className="servicio izq">
                        <div className="left">
                            <video autoPlay muted loop playsInline>
                                <source src={videoMaxilofacial} type="video/mp4" />
                            </video>
                        </div>
                        <div className="right">
                            <h3>Cirugía maxilofacial</h3>
                            <p>Se encarga de tratar quirúrgicamente los huesos de la cara, incluyendo extracciones, corrección de dientes impactados, deformidades, traumatismos, malformaciones o patologías, con el fin de mejorar la función, estética y salud del paciente.</p>
                            <button onClick={() => window.open('https://wa.me/2222382872?text=Hola,%20deseo%20agendar%20una%20cita%20en%20VeraDental%20para%20cirugia%20maxilofacial.', '_blank').focus()}>
                                <i className="fa-solid fa-tooth"></i>
                                <p>AGENDAR CITA CIRUGÍA MAXILOFACIAL</p>
                            </button>
                        </div>
                    </div>

                    <div className="servicio der">
                        <div className="left">
                            <video autoPlay muted loop playsInline>
                                <source src={videoOdontopediatria} type="video/mp4" />
                            </video>
                        </div>
                        <div className="right">
                            <h3>Odontopediatría</h3>
                            <p>La odontopediatría  es la especialidad encargada del cuidado y tratamiento dental exclusivamente en niños.<br/><br/>Su objetivo es prevenir, diagnosticar y tratar a tiempo problemas como caries o alteraciones en el crecimiento dental, además de enseñar hábitos de higiene bucal adecuados. Ayuda a que los dientes y la sonrisa de los niños se desarrollen sanos y fuertes desde las primeras etapas de vida.</p>
                            <button onClick={() => window.open('https://wa.me/2222382872?text=Hola,%20deseo%20agendar%20una%20cita%20en%20VeraDental%20para%20odontopediatria.', '_blank').focus()}>
                                <i className="fa-solid fa-tooth"></i>
                                <p>AGENDAR CITA PARA ODONTOPEDIATRÍA</p>
                            </button>
                        </div>
                    </div>

                    <div className="servicio izq">
                        <div className="left">
                            <video autoPlay muted loop playsInline>
                                <source src={videoEsteticaDental} type="video/mp4" />
                            </video>
                        </div>
                        <div className="right">
                            <h3>Estética Dental</h3>
                            <p>La estética dental junto con el diseño de sonrisa es un procedimiento intengral que ayuda a mejorar la apariencia de la sonrisa, cuidando el color, tamaño, forma y posición de los dientes para lograr un equilibrio entre salud, funcionalidad y belleza. <br/><br/>Entre sus tratamientos más comunes se encuentran el blanqueamiento dental, las carillas, las resinas estéticas, la alineación dental con ortodoncia o alineadores y la remodelación de encías. Todo con el objetivo de brindarte una sonrisa armónica, natural y llena de confianza.</p>
                            <button onClick={() => window.open('https://wa.me/2222382872?text=Hola,%20deseo%20agendar%20una%20cita%20en%20VeraDental%20para%20estetica%20dental.', '_blank').focus()}>
                                <i className="fa-solid fa-tooth"></i>
                                <p>AGENDAR CITA PARA ESTÉTICA DENTAL</p>
                            </button>
                        </div>
                    </div>

                    <div className="servicio der">
                        <div className="left">
                            <video autoPlay muted loop playsInline>
                                <source src={videoRehabilitacion} type="video/mp4" />
                            </video>
                        </div>
                        <div className="right">
                            <h3>Rehabilitación bucal</h3>
                            <p>La Rehabilitación bucal es la rama de la odontología que busca recuperar la funcionalidad, armonía  y la estética de la boca cuando existen  ausencias dentales o daños en los dientes. A través de diferentes tratamientos, se logra restaurar la mordida, mejorar la estética de la sonrisa y prevenir futuros problemas de salud bucal.<br/>Incluye tratamientos como coronas, puentes, prótesis fijas y removibles, implantes dentales y rehabilitaciones completas, dependiendo de las necesidades de cada persona.</p>
                            <button onClick={() => window.open('https://wa.me/2222382872?text=Hola,%20deseo%20agendar%20una%20cita%20en%20VeraDental%20para%20rehabilitacion%20bucal.', '_blank').focus()}>
                                <i className="fa-solid fa-tooth"></i>
                                <p>AGENDAR CITA PARA REHABILITACIÓN BUCAL</p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="sucursales" style={{"display":"none"}}>
                <h2 className='animate__animated animate__fadeInUp'>Donde comienza <b>tu mejor sonrisa</b></h2>

                <div className="address animate__animated animate__fadeIn">
                    <div className="left">
                        <h3>VeraDental <b>Plaza 1313</b></h3>
                        <p>C.11 Sur, Av 15 Pte #1313 - local 28, Barrio de Santiago, 72410 Heroica Puebla de Zaragoza, Pue.</p>
                        <p className='horario'>Lunes a viernes 10:00 am a 7:30 pm <br/> Sábado 10:00 am a 2:00 pm</p>
                        <button onClick={() => window.open('https://maps.app.goo.gl/L7PsUSTq2gmfWeEx7', '_blank').focus()}>
                            <i className="fa-solid fa-map-location-dot"></i>
                            <p>Google Maps</p>
                        </button>
                    </div>
                    <div className="right">
                        <img className='fondo' src={fachadaUbicacion}/>
                    </div>
                </div>

                <div style={{ width: '99%', height: '400px' }}>
                    <iframe
                        title="Mapa de ubicación"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.4615873812318!2d-98.21186552502347!3d19.043432582154473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cfc1f4d942849b%3A0x2c9787321d3ea4bc!2sVERADENTAL%20Ortodoncia%20%26%20Especialidades!5e0!3m2!1ses-419!2smx!4v1772424849961!5m2!1ses-419!2smx"
                        width="100%"
                        height="100%"
                        style={{ border: 0, borderRadius: '8px' }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>
            </div>

            <div id="contacto" style={{"display":"none"}}>
                <div className="title">
                    <h2 className='animate__animated animate__fadeIn'>Da el primer paso hacia <b>tu mejor sonrisa</b></h2>
                    <h1 className='animate__animated animate__fadeInUp'>¡Estamos a un mensaje de distancia!</h1>
                </div>

                <div className="contacto animate__animated animate__fadeIn">
                    <div className="call" onClick={() => window.open('tel:+522228895893', '_blank').focus()}>
                        <i className="fa-solid fa-phone"></i>
                        <p>22 28 89 58 93</p>
                    </div>

                    <div className="buttons">
                        <div className="button" onClick={() => window.open('https://www.tiktok.com/@dra.angelica.vera', '_blank').focus()}>
                            <i class="fa-brands fa-tiktok"></i>
                        </div>
                        <div className="button" onClick={() => window.open('https://wa.me/2222382872', '_blank').focus()}>
                            <i class="fa-brands fa-whatsapp"></i>
                        </div>
                        <div className="button" onClick={() => window.open('mailto:veradental.ortodoncia@gmail.com', '_blank').focus()}>
                            <i className="fa-solid fa-envelope"></i>
                        </div>
                        <div className="button" onClick={() => window.open('https://www.facebook.com/share/1DPrGb3x1g/', '_blank').focus()}>
                            <i class="fa-brands fa-facebook"></i>
                        </div>
                        <div className="button" onClick={() => window.open('https://www.instagram.com/dra.angelicavera_ortodoncista?igsh=MTczYmhhcGRubDg4ZQ==', '_blank').focus()}>
                            <i class="fa-brands fa-instagram"></i>
                        </div>
                    </div>
                </div>
            </div>

            <footer>
                <div className="left">
                    <img src={logo_negativo}/>
                    <div className="redes">
                        <div className="option" onClick={() => window.open('https://www.facebook.com/share/1DPrGb3x1g/', '_blank').focus()}>
                            <i className="fa-brands fa-facebook"></i>
                        </div>
                        <div className="option" onClick={() => window.open('https://www.instagram.com/dra.angelicavera_ortodoncista?igsh=MTczYmhhcGRubDg4ZQ==', '_blank').focus()}>
                            <i className="fa-brands fa-instagram"></i>
                        </div>
                        <div className="option" onClick={() => window.open('https://www.tiktok.com/@dra.angelica.vera', '_blank').focus()}>
                            <i className="fa-brands fa-tiktok"></i>
                        </div>
                    </div>
                </div>
                <div className="right">
                    <div className="sections">
                        <p onClick={() => {
                            document.getElementById("inicio").style.display = "block";
                            document.getElementById("servicios").style.display = "none";
                            document.getElementById("sucursales").style.display = "none";
                            document.getElementById("contacto").style.display = "none";
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }}>Inicio</p>
                        <p onClick={() => {
                            document.getElementById("inicio").style.display = "none";
                            document.getElementById("servicios").style.display = "block";
                            document.getElementById("sucursales").style.display = "none";
                            document.getElementById("contacto").style.display = "none";
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }}>Servicios dentales</p>
                        <p onClick={() => {
                            document.getElementById("inicio").style.display = "none";
                            document.getElementById("servicios").style.display = "none";
                            document.getElementById("sucursales").style.display = "block";
                            document.getElementById("contacto").style.display = "none";
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }}>Sucursales</p>
                        <p onClick={() => {
                            document.getElementById("inicio").style.display = "none";
                            document.getElementById("servicios").style.display = "none";
                            document.getElementById("sucursales").style.display = "none";
                            document.getElementById("contacto").style.display = "block";
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }}>Contacto</p>
                    </div>
                    <h4>Copyright © 2025 - VeraDental.</h4>
                    <p className='db'>Designed by <b onClick={() => window.open('https://www.kisystems.com.mx/servicios', '_blank').focus()}>Ki Systems</b></p>
                </div>
            </footer>
        </React.Fragment>
    );
};

export default Menu;